module.exports = __webpack_public_path__ + "img/edit_user_tags_open.b746ac07.png";